import { useDebouncedCallUrl } from '@hooks'

import type { OnOpenChangeCallbackProps } from '@components/ui/Popover'

import type { PaidStatusIndicatorProps } from './elements'
import { PaidStatusHistory, PaidStatusIndicator } from './elements'

export interface PureAsyncPaidStatusProps extends Pick<PaidStatusIndicatorProps, 'value'> {
  historyUrl: string
  invoiceCurrencyId: number
}

export function AsyncPaidStatus({ historyUrl, invoiceCurrencyId, value, ...rest }: PureAsyncPaidStatusProps) {
  const { fetched, loading, results, handleOpen, handleClose } = useDebouncedCallUrl<{
    history: BackendInvoicePaymentHistoryResults
  }>(historyUrl)

  function onOpenChangeCallback({ nextOpen }: OnOpenChangeCallbackProps) {
    if (nextOpen) {
      handleOpen()
    } else {
      handleClose()
    }
  }

  return (
    <PaidStatusIndicator
      {...rest}
      onOpenChangeCallback={onOpenChangeCallback}
      title={
        <PaidStatusHistory
          fetched={fetched}
          data={results?.history ?? []}
          invoiceCurrencyId={invoiceCurrencyId}
          loading={loading}
          value={value}
        />
      }
      value={value}
    />
  )
}
